import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const receiptUrl = (id) => `${API}/donations/${id}/receipt`;

export const memberCardUrl = (id) => `${API}/members/${id}/card`;

export const api = {
  getConfig: () => axios.get(`${API}/config`).then((r) => r.data),
  getStats: () => axios.get(`${API}/donations/stats`).then((r) => r.data),
  getRecent: () => axios.get(`${API}/donations/recent`).then((r) => r.data),
  createOrder: (payload) =>
    axios.post(`${API}/donations/order`, payload).then((r) => r.data),
  verifyDonation: (payload) =>
    axios.post(`${API}/donations/verify`, payload).then((r) => r.data),
  manualDonation: (payload) =>
    axios.post(`${API}/donations/manual`, payload).then((r) => r.data),
  joinMember: (payload) =>
    axios.post(`${API}/members`, payload).then((r) => r.data),
  getEvents: () => axios.get(`${API}/events`).then((r) => r.data),
  adminEvents: (token) =>
    axios.get(`${API}/admin/events`, authHeader(token)).then((r) => r.data),
  adminCreateEvent: (token, payload) =>
    axios.post(`${API}/admin/events`, payload, authHeader(token)).then((r) => r.data),
  adminUpdateEvent: (token, id, payload) =>
    axios.put(`${API}/admin/events/${id}`, payload, authHeader(token)).then((r) => r.data),
  adminDeleteEvent: (token, id) =>
    axios.delete(`${API}/admin/events/${id}`, authHeader(token)).then((r) => r.data),
  getMedia: () => axios.get(`${API}/media`).then((r) => r.data),
  mediaFileUrl: (id) => `${API}/media/${id}/file`,
  adminUploadMedia: (token, formData) =>
    axios
      .post(`${API}/admin/media`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((r) => r.data),
  adminDeleteMedia: (token, id) =>
    axios.delete(`${API}/admin/media/${id}`, authHeader(token)).then((r) => r.data),
  exportCsv: (token, kind) =>
    axios
      .get(`${API}/admin/${kind}.csv`, {
        ...authHeader(token),
        responseType: "blob",
      })
      .then((r) => r.data),
  adminLogin: (password) =>
    axios.post(`${API}/auth/login`, { password }).then((r) => r.data),
  adminMe: (token) =>
    axios.get(`${API}/auth/me`, authHeader(token)).then((r) => r.data),
  adminDonations: (token) =>
    axios.get(`${API}/admin/donations`, authHeader(token)).then((r) => r.data),
  adminMembers: (token) =>
    axios.get(`${API}/admin/members`, authHeader(token)).then((r) => r.data),
};
